import { VersaoStatus, VersaoTipo } from '../generated/backend-enums.js';
export { VersaoStatus, VersaoTipo };
export const VersaoStatusMap = {
    [VersaoStatus.EM_REVISAO]: 'Em Revisão',
    [VersaoStatus.EM_APROVACAO]: 'Em Aprovação',
    [VersaoStatus.REPROVADO]: 'Reprovado',
    [VersaoStatus.CANCELADO]: 'Cancelado',
    [VersaoStatus.AGUARDANDO]: 'Aguardando',
    [VersaoStatus.RASCUNHO]: 'Rascunho',
    [VersaoStatus.APROVADO_INTERNAMENTE]: 'Aprovado Internamente',
    [VersaoStatus.ENVIADO_CLIENTE]: 'Enviado ao Cliente',
    [VersaoStatus.APROVADO]: 'Aprovado',
    [VersaoStatus.APROVADO_PARCIALMENTE]: 'Aprovado Parcialmente',
    [VersaoStatus.REPROVADO_CLIENTE]: 'Reprovado Cliente',
    [VersaoStatus.DESAPROVADO]: 'Desaprovado',
};
export const VersaoStatusTooltipMap = {
    [VersaoStatus.RASCUNHO]: 'Versão em elaboração. Ainda não passou por revisão ou aprovação.',
    [VersaoStatus.EM_REVISAO]: 'Versão em revisão interna para ajustes e validações.',
    [VersaoStatus.EM_APROVACAO]: 'Versão enviada para aprovação. Aguardando decisão dos revisores responsáveis.',
    [VersaoStatus.APROVADO_INTERNAMENTE]: 'Versão aprovada internamente. Pronta para envio ao cliente.',
    [VersaoStatus.ENVIADO_CLIENTE]: 'Proposta comercial enviada ao cliente. Alterações ou cancelamentos não são mais permitidos.',
    [VersaoStatus.APROVADO_PARCIALMENTE]: 'Versão aprovada com ressalvas. Algumas pendências ainda precisam ser resolvidas.',
    [VersaoStatus.APROVADO]: 'Versão totalmente aprovada e considerada final.',
    [VersaoStatus.REPROVADO]: 'Versão reprovada durante a revisão interna. Requer correções antes de nova submissão.',
    [VersaoStatus.REPROVADO_CLIENTE]: 'Versão reprovada pelo cliente. Ajustes necessários antes de reenvio.',
    [VersaoStatus.DESAPROVADO]: 'Versão rejeitada e considerada inválida para uso.',
    [VersaoStatus.AGUARDANDO]: 'Versão aguardando ação, decisão ou resposta para seguir o fluxo.',
    [VersaoStatus.CANCELADO]: 'Versão cancelada e inativa. Não pode mais ser alterada ou utilizada.',
};
export const VersaoTipoMap = {
    [VersaoTipo.CLIENTE]: 'Proposta Comercial',
    [VersaoTipo.INTERNO]: 'Ajuste Interno',
    [VersaoTipo.COMPRAS]: 'Ajuste Compras',
    [VersaoTipo.ATENDIMENTO]: 'Incremento Complementar',
};
